<template>
  <v-card :elevation="elevation" :height="height" class="rounded-lg" :outlined="outlined">
    <v-card-title v-if="title || showExpand" class="text-subtitle-1 pt-2">
      {{ title }}
      <v-progress-circular
        v-if="loading"
        class="ml-2"
        size="16"
        width="2"
        color="secondary"
        indeterminate
      ></v-progress-circular>
      <v-spacer />
      <slot name="append-title"></slot>
      <v-tooltip v-if="showExpand" top>
        <template #activator="{ on }">
          <v-icon v-on="on" @click="$emit('expand')">mdi-fullscreen</v-icon>
        </template>
        <span>Expand</span>
      </v-tooltip>
    </v-card-title>
    <v-card-subtitle class="text-caption pb-2">{{ subtitle }}</v-card-subtitle>
    <v-card-text class="pa-1">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Widget",
  components: {},
  mixins: [],
  props: {
    title: { type: String, required: false, default: "" },
    subtitle: { type: String, required: false, default: "" },
    elevation: { type: Number, required: false, default: 0 },
    height: { type: [Number, String], required: false, default: undefined },
    outlined: { type: Boolean, required: false, default: true },
    showExpand: { type: Boolean, required: false, default: false },
    loading: { type: Boolean, required: false, default: false },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
};
</script>

<style></style>
